import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

export interface FeaturesGridListProps {
  featuresList?: string[];
}

export function FeaturesGridList({ featuresList }: FeaturesGridListProps) {
  return (
    <div className='block w-full h-full flex-1'>
      <div className='grid grid-cols-1 min-[500px]:grid-cols-2 flex-1 gap-y-3 gap-x-3'>
        {featuresList?.map((feature) => {
          return (
            <div key={feature} className='flex flex-row gap-x-2 items-center'>
              <FontAwesomeIcon
                icon={faCheck}
                className='w-4 h-4 v2-text-blue-500'
              />
              <span className='text-base v2-text-neutral-900'>{feature}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
